import * as React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import Multi from './Multi.js';

export function Location({ autoFill, filters, updateState }) {
    const LocationAutofill = autoFill.Location.map(itm => {
        return {
            "name": itm.label,
            "id": itm.id,
        };
    });
    const SharedWithClientAutofill = autoFill.SharedWithCliend.map(itm => {
        return {
            "name": itm.name,
            "id": itm.id,
        };
    });
    const HandedToClientAutofill = autoFill.HandedOverToClients
        .map(itm => ({
            "name": itm.name,
            "id": itm.id,
        }))
        .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));

    

    return (
        <div className='attirubutes-filter-container'>
            <div className='input-container'><SingleSelectInput options={SharedWithClientAutofill} value={filters.subquery___amal_sharing___fk_client___fk_card___id} updateState={updateState} filterKey="subquery___amal_sharing___fk_client___fk_card___id" inputName="Has been shared with this client (currently or in the past)" /> </div>
            <div className='input-container'><Multi value={filters.containsany___location_id} filterKey="containsany___location_id" updateState={updateState} options={LocationAutofill || []}  inputName="Location" /></div>
            <div className='input-container'><SingleSelectInput options={HandedToClientAutofill} value={filters.equalto___handed_over_to_userid} updateState={updateState} filterKey="equalto___handed_over_to_userid" inputName="Out with this employee/client" /> </div>
            {/* <div className="input-container"><DatePickerInput value={filters.sharedTillDate} updateState={updateState} filterKey="sharedTillDate" label="Shared with a client till" /></div>
            <div className="input-container"><DatePickerInput value={filters.returnDate} updateState={updateState} filterKey="returnDate" label="Expected return date" /></div> */}
            <div className='input-container'>
                <FormControl size="small" fullWidth={true}>
                    <TextField  value={filters.boxNumber} onChange={e => updateState({ "boxNumber": e.target.value })} size='small' fullWidth label="Box number" id="fullWidth" />
                </FormControl>
            </div> 
        </div>

    );
}
export function SingleSelectInput({ options, value, updateState, filterKey, inputName }) {
    const handelClick = (id) => {
        // console.log(id, value)
        if (id === value){
            updateState({ [filterKey]: "" })
        }
    }
    return <Box>
        <FormControl size="small" fullWidth>
            <InputLabel id="demo-simple-select-label">{inputName}</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={value}
                label={inputName}
                onChange={(event) => updateState({ [filterKey]: event.target.value })}
            >
                {options.map((option) => (
                    <MenuItem onClick={() => handelClick(option.id)} key={option.id} value={option.id}>
                        {option.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    </Box>;
}
// eslint-disable-next-line
function DatePickerInput({ label, value, updateState, filterKey }) {
    function handelChange(newdate, type) {
        updateState({
            [filterKey]: {
                ...value,
                [type]: newdate,
            }
        });
    }

    return (
        <div className='date-picker'>
            <InputLabel id="date-input-label">{label}</InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer sx={{ display: "flex", justifyContent: "space-between", mt: 0.5, alignItems: "center" }} components={['DatePicker', 'DatePicker']}>
                    <DatePicker
                        sizeSmall
                        size="small"
                        label="Start Date"
                        value={value.start}
                        format='DD/MM/YYYY'
                        onChange={(newValue) => handelChange(newValue, "start")}
                        slotProps={{
                            TextField: {
                                margin: "normal"
                            }
                        }} />
                    <p className='devider'>~</p>
                    <DatePicker
                        label="End Date"
                        value={value.end}
                        format='DD/MM/YYYY'
                        onChange={(newValue) => handelChange(newValue, "end")} />
                </DemoContainer>
            </LocalizationProvider>
        </div>

    );
}
